import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { RouterStore } from 'mobx-react-router';
import RSVPSettingsPage from './containers/rsvp-settings-page';
import AddressCollectionPage from './containers/address-collection-page';
import ImportSpreadsheetPage from './components/import-spreadsheet/import-spreadsheet-page';
import GuestListPage from './containers/guest-list-page';

const GLMRouter = () => (
  <Switch>
    <Route path="/our-guest-list/address-collection" component={AddressCollectionPage} />
    <Route path="/our-guest-list/import-spreadsheet" component={ImportSpreadsheetPage} />
    <Route path="/our-guest-list/rsvp-settings" component={RSVPSettingsPage} />
    <Route path="/our-guest-list" component={GuestListPage} />
  </Switch>
);

GLMRouter.propTypes = {
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default inject('routerStore')(withRouter(observer(GLMRouter)));
